/**
 * AFW Product Enhancements
 * - Broken image fallback (replaces with AFW placeholder)
 * - Lazy image error handling
 */
(function() {
  'use strict';

  var PLACEHOLDER = 'https://cdn.shopify.com/s/files/1/0627/3476/2108/files/afw-placeholder-product.png';
  var handled = new WeakSet();

  function handleBrokenImage(img) {
    if (handled.has(img)) return;
    handled.add(img);
    img.src = PLACEHOLDER;
    if (img.dataset.src) img.dataset.src = PLACEHOLDER;
    img.alt = img.alt || 'Product image coming soon';
  }

  // Handle images that fail to load
  document.addEventListener('error', function(e) {
    var el = e.target;
    if (el.tagName === 'IMG' && el.closest('.t4s-product-img, .t4s-product')) {
      handleBrokenImage(el);
    }
  }, true);

  // Also catch lazysizes errors
  document.addEventListener('lazyloaded', function(e) {
    var img = e.target;
    if (img.tagName === 'IMG' && img.naturalWidth === 0) {
      handleBrokenImage(img);
    }
  });
})();
